import { PreferencesUtilisateur } from '@/model/preferences-utilisateur/preferences-utilisateur';
import Axios from 'axios';
import { JsonTsMapper } from 'json-ts-mapper';
import { ApiUtils } from './api-utils';

export class PreferenceUtilisateurApi {
  static getPreferenceUtilisateur (userName: string): Promise<PreferencesUtilisateur> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/users/${userName}/preference-utilisateur`), PreferencesUtilisateur);
  }

  static savePreferenceUtilisateur (userName: string, preferenceUtilisateur: PreferencesUtilisateur): Promise<void> {
    return Axios.put(`/web/v1/users/${userName}/preference-utilisateur`, JsonTsMapper.serialize(preferenceUtilisateur)).then(() => { });
  }
}
